export const validateGreaterThan =
  (minValue: number | string, message: string) =>
  (value: number | string): true | string => {
    const min = Number(minValue);
    const max = Number(value);
    if (Number.isNaN(min) || Number.isNaN(max)) return true;
    return max > min || message;
  };
